import { combineReducers } from "redux";
import { reducer as notifReducer } from "redux-notifications";
import {
  ASSETS_RESOURCE,
  CALENDAR_RESOURCE,
  DEVICE_GROUPS_RESOURCE,
  DEVICE_UNGROUP_WRAPERS_RESOURCE,
  DEVICES_RESOURCE,
  FEED_RESOURCE,
  NOTIFICATION_RESOURCE,
  PLAYLISTS_RESOURCE,
  CHANNELS_RESOURCE,
  TICKER_SERIES_RESOURCE,
  PLAYLIST_TAGS_RESOURCE,
  TICKERS_RESOURCE,
  UNGROUPED_DEVICES_RESOURCE,
  WEB_RESOURCE,
  WEB_TEMPLATE_RESOURCE,
  USER_RESPORT_ACTIIVITIES_RESOURCE,
  SUBUSER_RESOURCE,
  USERPROFILE_RESOURCE,
  CUSTOM_WEB_TEMPLATE_RESOURCE,
  CAMPAIGN_RESOURCE,
  DEVICE_TAGS_RESOURCE,
  SCROLLER_TEMPLATE_RESOURCE,
  PLAYLISTS_RESOURCE_V2,
  ASSETS_TAGS_RESOURCE,
  SCROLLER_TEMPLATE_RESOURCE,
} from "signoxe/api/resources";
import filterState from "signoxe/reducers/filterState";
import { assetTags } from "signoxe/reducers/tags";
import { playlistTags } from "signoxe/reducers/ptags";

import authState from "./authState";
import { entities, resourceReducer } from "./resourceReducer";
import uiState from "./uiState";
import deviceState from "./deviceState";
import uploadsReducer from "./uploadsReducer";
import paginationState from "./pageReducer";
import campaignState from "./campaignReducer";

const rootReducer = combineReducers({
  devices: resourceReducer([DEVICES_RESOURCE, UNGROUPED_DEVICES_RESOURCE]),
  deviceGroups: resourceReducer([DEVICE_GROUPS_RESOURCE]),
  deviceUngroupWrapers: resourceReducer([DEVICE_UNGROUP_WRAPERS_RESOURCE]),
  assets: resourceReducer([
    ASSETS_RESOURCE,
    FEED_RESOURCE,
    WEB_RESOURCE,
    CALENDAR_RESOURCE,
  ]),
  webAssetTemplates: resourceReducer([WEB_TEMPLATE_RESOURCE]),
  customTemplates: resourceReducer([CUSTOM_WEB_TEMPLATE_RESOURCE]),
  scrollerTemplates : resourceReducer([SCROLLER_TEMPLATE_RESOURCE]),
  playlists: resourceReducer([PLAYLISTS_RESOURCE]),
  playlistsV2:resourceReducer([PLAYLISTS_RESOURCE_V2]),
  channels: resourceReducer([CHANNELS_RESOURCE]),
  tickerSeries: resourceReducer([TICKER_SERIES_RESOURCE]),
  listTags: resourceReducer([PLAYLIST_TAGS_RESOURCE]),
  tickers: resourceReducer([TICKERS_RESOURCE]),
  userReports:resourceReducer([USER_RESPORT_ACTIIVITIES_RESOURCE]),
  notifications: resourceReducer([NOTIFICATION_RESOURCE]),
  subusers: resourceReducer([SUBUSER_RESOURCE]),
  userprofile: resourceReducer([USERPROFILE_RESOURCE]),
  profileuser: resourceReducer([USERPROFILE_RESOURCE]),
  deviceTags: resourceReducer([DEVICE_TAGS_RESOURCE]),
  assetTags: resourceReducer([ASSETS_TAGS_RESOURCE]),
  entities: entities,
  uploads: uploadsReducer,
  uiState,
  authState,
  deviceState,
  paginationState,
  notifs: notifReducer,
  filters: filterState,
  tags: assetTags,
  ptags: playlistTags,
  campaigns: resourceReducer([CAMPAIGN_RESOURCE]),
  playlist: null,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/reducers/index.js